import {createContext, useCallback, useState} from "react";
import {DRIVE_TYPES, PERMISSIONS, UPLOAD_STATUS} from "../config/appConst";

export const DriveContext = createContext({
    CurrentDrive: null,
    changeCurrentDrive: () => {
    },
    renameRow: null,
    changeRenameRow: () => {
    },
    renameFolder: null,
    changeRenameFolder: () => {
    },
    copyPath: null,
    changeCopyPath: () => {
    },
    uploadStatus: UPLOAD_STATUS.DONE,
    changeUploadStatus: () => {
    },
    deleteKey: null,
    changeDeleteKey: () => {
    },
    selectedRow: null,
    changeSelectedRow: () => {
    },
    previewObject: null,
    changePreviewObject: () => {
    },
    editorObject: null,
    changeEditorObject: () => {
    },
    uploadProgress: null,
    changeUploadProgress: () => {
    },
    layout: null,
    changeLayout: () => {
    }
});

export default function DriveProvider({children}) {
    const [CurrentDrive, setCurrentDrive] = useState(null);
    const [renameRow, setRenameRow] = useState(null);
    const [renameFolder, setRenameFolder] = useState(null);
    const [copyPath, setCopyPath] = useState(null);
    const [uploadStatus, setUploadStatus] = useState(UPLOAD_STATUS.DONE);
    const [deleteKey, setDeleteKey] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [previewObject, setPreviewObject] = useState(null);
    const [editorObject, setEditorObject] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [layout, setLayout] = useState(window.navigator.maxTouchPoints > 1 ? "GRID": "LIST");

    const changeEditorObject = row => {
        setEditorObject(row);
    }
    const changePreviewObject = row => {
        setPreviewObject(row);
    }
    const changeSelectedRow = (row) => {
        setSelectedRow(row);
    }

    const changeDrive = ({parent, drive, sharedDrive,  driveType, drivePermission}) => {
        setCurrentDrive({parent, drive, sharedDrive, driveType, drivePermission})
    }

    const changeRenameRow = row => {
        setRenameRow(row);
    }

    const changeRenameFolder = row => {
        setRenameFolder(row);
    }

    const changeCopyPath = ({path, type, name, sourceDrive}) => {
        setCopyPath({path, type, name, sourceDrive});
    }

    const changeUploadStatus = status => {
        setUploadStatus(status);
    }

    const changeDeleteKey = key => {
        setDeleteKey(key);
    }
    const changeUploadProgress = key => {
        setUploadProgress(key);
    }
    const changeLayout = key => {
        setLayout(key);
    }

    const contextValue = {
        CurrentDrive: CurrentDrive,
        changeCurrentDrive: useCallback(
            ({parent, drive, sharedDrive, driveType}) => {
                let tmpDrive = {parent, driveType};
                // console.log("tmpDrive", tmpDrive)
                let permission = PERMISSIONS.VIEW;
                if (driveType === DRIVE_TYPES.SHARED) {
                    sharedDrive = !sharedDrive ? (drive ? drive : {}) : sharedDrive;
                    const {Permissions} = sharedDrive;
                    const editable = Permissions.findIndex( p => {
                        return p === PERMISSIONS.WRITE;
                    })
                    if (editable > -1) {
                        permission = PERMISSIONS.WRITE;
                    }
                    tmpDrive["drive"] = {};
                    tmpDrive["sharedDrive"] = !sharedDrive ? (drive ? drive : {}) : sharedDrive;
                } else {
                    permission = PERMISSIONS.WRITE;
                    tmpDrive["drive"] = drive;
                    tmpDrive["sharedDrive"] = {};
                }
                tmpDrive["permission"] = permission;
                // console.log("drivePermission", permission)
                changeDrive({parent, drive, sharedDrive, driveType, drivePermission: permission})
            }, []),
        renameRow: renameRow,
        changeRenameRow: useCallback(row => {
            changeRenameRow(row)
        }, []),
        renameFolder: renameFolder,
        changeRenameFolder: useCallback(row => {
            changeRenameFolder(row)
        }, []),
        copyPath: copyPath,
        setCopyPath: useCallback(({path, type, name, sourceDrive}) => {
            changeCopyPath({path, type, name, sourceDrive});
        }, []),
        uploadStatus: uploadStatus,
        changeUploadStatus: useCallback(status => {
            changeUploadStatus(status)
        }, []),
        deleteKey: deleteKey,
        changeDeleteKey: useCallback(key => {
            changeDeleteKey(key);
        }, []),
        selectedRow: selectedRow,
        changeSelectedRow: useCallback(row => {
            changeSelectedRow(row);
        }, []),
        previewObject: previewObject,
        changePreviewObject: useCallback(row => {
            changePreviewObject(row)
        },[]),
        editorObject: editorObject,
        changeEditorObject: useCallback(row => {
            changeEditorObject(row)
        }
        ,[]),
        onUploadProgress: uploadProgress,
        changeUploadProgress: useCallback(row => {
           changeUploadProgress(row)
        }
        ,[]),
        layout: layout,
        changeLayout: useCallback(row => {
            changeLayout(row)
        }, [])
    }

    return <DriveContext.Provider value={contextValue}>
        {children}
    </DriveContext.Provider>
}